import React from 'react'
import cx from 'classnames'

import { renderModules } from '@/utls.js'

import META from '@/meta.js'
import Footer from '@/footer.js'
import AboutHero from '@/heros/aboutHero.js'
import ComingSoon from '@/modules/comingSoon.js'
import { queryAbout } from '../utls/queryAbout.js'
import ThemeProvider from '@/themeProvider.js'

const About = ({ transitionStatus, entry, exit }) => {
  const data = queryAbout()
  const metaData = {
    title: data.metaInfo ? data.metaInfo.metaTitle || data.titleOne : data.titleOne,
    keywords: data.metaInfo ? data.metaInfo.keywords || '' : '',
    description: data.metaInfo ? data.metaInfo.description || data.description : data.description,
    url: 'about',
    image: data.headerImages[0].image,
    ogTitle: data.metaInfo ? data.metaInfo.title || data.titleOne : data.titleOne,
    ogDescription: data.metaInfo ? data.metaInfo.openGraphDescription || data.description : data.description,
    ogImage: data.metaInfo ? data.metaInfo.openImage || data.headerImages[0].image : data.headerImages[0].image,
    twitterImage: data.metaInfo ? data.metaInfo.twitterImage || data.headerImages[0].image : data.headerImages[0].image,
    twitterTitle: data.metaInfo ? data.metaInfo.twitterTitle || data.titleOne : data.titleOne,
    twitterDescription: data.metaInfo ? data.metaInfo.twitterDescription || data.description : data.description
  }
  return (
    <div className={cx('animate__page', transitionStatus)}>
      <META metaData={metaData} />
      <ThemeProvider color={`two`} />
      <div className='nav--spacer' />
      <AboutHero {...data} />
      {renderModules(data.modules)}
      <ComingSoon />
      <Footer />
    </div>
  )
}

export default About
